import React, { useState } from 'react'
import { Box, Button, FormControl, FormHelperText, InputLabel, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { ApiAddCategory, ApiUpdateCategory, ApiuploadDocuments } from '../../../apiService/Core/Apicall.tsx';
import { setLoadingFalse, setLoadingTrue } from '../../../global/config/Action/loadingActions.ts';
import store from '../../../global/config/store.ts';
import imageCompression from 'browser-image-compression';
import upload from '../../../assets/images/upload.png';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useLocation, useNavigate } from 'react-router-dom'






interface FormValues {
  categoryName: string
  categoryWeightage: number
  mmUrl: string
  isActive: boolean
  transportUrl: string
  bloomsUrl: string
  aldiUrl: string
  createdBy?: string
  modifiedBy?: string
}
function AddorUpdateCategory() {
  const navigate = useNavigate()
  const location = useLocation();
  const questionData = location.state?.questionData;

  const initialValues: FormValues = {
    categoryName: (questionData?.categoryName) || '',
    categoryWeightage: (questionData?.categoryWeightage) || 1,
    mmUrl: (questionData?.mmUrl) || '',
    isActive: true,
    transportUrl: (questionData?.transportUrl) || '',
    bloomsUrl: (questionData?.bloomsUrl) || '',
    aldiUrl: (questionData?.aldiUrl) || '',
    [(questionData ? 'modifiedBy' : 'createdBy')]: 'admin',
  };
  const validationSchema = Yup.object({
    categoryName: Yup.string().required("Enter question name"),
    mmUrl: Yup.string().required("Image Icon is Requierd "),
    transportUrl: Yup.string().required("Image Icon is Requierd "),
    bloomsUrl: Yup.string().required("Image Icon is Requierd "),
    aldiUrl: Yup.string().required("Image Icon is Requierd "),
  })

  const onSubmit = async (values: FormValues) => {
    try {
      const payload = {
        categoryWeightage: values.categoryWeightage,
        mmUrl: values.mmUrl,
        isActive: true,
        transportUrl: values.transportUrl,
        bloomsUrl: values.bloomsUrl,
        aldiUrl: values.aldiUrl,
        [(questionData ? 'modifiedBy' : 'createdBy')]: 'admin',
      };

      if (questionData?.categoryName !== values.categoryName) {
        payload.categoryName = values.categoryName;
      }
      if(questionData){
        payload.categoryId = questionData?.categoryId
      }
      const response = questionData ? await ApiUpdateCategory(payload) : await ApiAddCategory(values);
      toast.success(response.message)
      navigate('/admin/others/category-list')
    }
    catch (error) {
      toast.error(error)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit
  });

  const fileupload = async (filePath: any, fileType: any, BusinessName: string) => {
    // const userData: any = localStorage.getItem('userData');
    const formData = new FormData();
    // formData.append("userId", userData.userId);
    formData.append("fileType", fileType);
    formData.append("file", filePath); // Add a file
    try {
      const response: any = await ApiuploadDocuments(formData);
      if (response.status) {
        console.log("Uploaded File URL", response)
        formik.setFieldValue(BusinessName, response.location)
        // return response.location;
        toast.success("Image uploaded Successfully")
      }
    }
    catch (error) {
      toast.error(error)
    }

  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>, BusinessName) => {
    const file = event.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      try {
        store.dispatch(setLoadingTrue())
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);

        fileupload(compressedFile, 'category_image', BusinessName);
      } catch (error) {
        console.error("Image compression failed:", error);
        alert("Image compression failed. Please try again.");
      }
      finally {
        store.dispatch(setLoadingFalse())
      }
    } else {
      alert("Please upload a valid image file.");
    }
  };

  const handleRemove = (Business: string) => {
    // setuploadedimage(prev => prev.filter((_, index) => index !== indexToRemove));
    formik.setFieldValue(Business, '');
  };


  return (
    <Box className='container-fluid p-3 extra' bgcolor='white' minHeight='calc(100vh - 180px)'>
      <form onSubmit={formik.handleSubmit}>
        <Box className='d-flex align-items-center justify-content-between'>
          <Typography className='fw-bold' variant='h5'> {questionData.length > 0 ? 'Add':"Update"} Category</Typography>
          <Button variant="contained" type='submit' className="table-row-background my-1" sx={{ width: 'fit-content', textTransform: 'none' }}>{questionData.length > 0 ? 'Add':"Update"} Category</Button>
        </Box>
        <Box className='mt-3'>
          <Box className='d-flex align-items-start justify-content-between' gap={1}>
            <FormControl className=" col-8 my-3 mt-4">
              <InputLabel shrink={false}>Category Name</InputLabel>
              <TextField
                className="w-100"
                placeholder="Enter Category Name..."
                variant="outlined"
                fullWidth
                name="categoryName"
                value={formik.values.categoryName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.categoryName && Boolean(formik.errors.categoryName)}
              />
              {formik.touched.categoryName && formik.errors.categoryName && (
                <FormHelperText sx={{ color: 'red' }}>{formik.errors.categoryName}</FormHelperText>
              )}
            </FormControl>
            <FormControl className=" col-4 my-3 mt-4">
              <InputLabel id="demo-simple-select-label" shrink={false}>Question Weightage</InputLabel>
              <TextField
                onBlur={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (isNaN(value) || value <= 0) {
                    toast.error('Number Should be more than Zero')
                    formik.setFieldValue('questionWeightage', 1);
                  }
                }}
                inputProps={{ min: 1 }} type="number"
                name='categoryWeightage'
                value={formik.values.categoryWeightage}
                onChange={formik.handleChange}
                error={formik.touched.categoryWeightage && Boolean(formik.errors.categoryWeightage)}
                helperText={
                  formik.touched.categoryWeightage && typeof formik.errors.categoryWeightage === 'string'
                    ? formik.errors.categoryWeightage
                    : ''
                }
              />
            </FormControl>
          </Box>
          <Box className='d-flex align-items-center gap-1'>
            <FormControl className='col-3 my-3 mt-4'>
              <Typography className='' variant='subtitle2'>MM Icon</Typography>
              <Box
                className="mt-2 d-flex align-items-center justify-content-center"
                height={300}
                width={{ xs: '100%', md: '300px !important' }}
                border="1px dashed #00000033"
                borderRadius={5}
                sx={{ cursor: 'pointer' }}
              >
                {formik.values.mmUrl.length === 0 ? (
                  <Box className="image-container" position="relative" width="fit-content">
                    <label
                      htmlFor="file-upload"
                      className="form-caption"
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(event) => handleFileChange(event, 'mmUrl')}
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box
                          component="img"
                          height={36}
                          width={36}
                          src={upload}
                          alt="Upload"
                        />
                        <Typography className="form-caption">Upload Here</Typography>
                      </Box>
                    </label>
                  </Box>
                ) : (
                  <Box className="image-container" position="relative" width="fit-content">
                    <Box
                      component="img"
                      className="uploadedImg"
                      alt="MM Icon"
                      src={formik.values.mmUrl}
                      height={300}
                      width="auto"
                    />
                    <Box className="cancel-button">
                      <CancelOutlinedIcon
                        sx={{ color: 'black' }}
                        onClick={() => handleRemove('mmUrl')}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              {formik.touched.mmUrl && formik.errors.mmUrl && (
                <FormHelperText sx={{ color: 'red' }}>{formik.errors.mmUrl}</FormHelperText>
              )}
            </FormControl>
            <FormControl className='col-3 my-3 mt-4'>
              <Typography className='' variant='subtitle2'>Blooms Icon</Typography>
              <Box
                className="mt-2 d-flex align-items-center justify-content-center"
                height={300}
                width={{ xs: '100%', md: '300px !important' }}
                border="1px dashed #00000033"
                borderRadius={5}
              >
                {formik.values.bloomsUrl.length === 0 ? (
                  <Box className="image-container" position="relative" width="fit-content">
                    <label
                      htmlFor="file-upload"
                      className="form-caption"
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(event) => handleFileChange(event, 'bloomsUrl')}
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box
                          component="img"
                          height={36}
                          width={36}
                          src={upload}
                          alt="Upload"
                        />
                        <Typography className="form-caption">Upload Here</Typography>
                      </Box>
                    </label>
                  </Box>
                ) : (
                  <Box className="image-container" position="relative" width="fit-content">
                    <Box
                      component="img"
                      className="uploadedImg"
                      alt="MM Icon"
                      src={formik.values.bloomsUrl}
                      height={300}
                      width="auto"
                    />
                    <Box className="cancel-button">
                      <CancelOutlinedIcon
                        sx={{ color: 'black' }}
                        onClick={() => handleRemove('bloomsUrl')}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              {formik.touched.bloomsUrl && formik.errors.bloomsUrl && (
                <FormHelperText sx={{ color: 'red' }}>{formik.errors.bloomsUrl}</FormHelperText>
              )}
            </FormControl>
            <FormControl className='col-3 my-3 mt-4'>
              <Typography className='' variant='subtitle2'>Transport Icon</Typography>
              <Box
                className="mt-2 d-flex align-items-center justify-content-center"
                height={300}
                width={{ xs: '100%', md: '300px !important' }}
                border="1px dashed #00000033"
                borderRadius={5}
              >
                {formik.values.transportUrl.length === 0 ? (
                  <Box className="image-container" position="relative" width="fit-content">
                    <label
                      htmlFor="file-upload"
                      className="form-caption"
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(event) => handleFileChange(event, 'transportUrl')}
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box
                          component="img"
                          height={36}
                          width={36}
                          src={upload}
                          alt="Upload"
                        />
                        <Typography className="form-caption">Upload Here</Typography>
                      </Box>
                    </label>
                  </Box>
                ) : (
                  <Box className="image-container" position="relative" width="fit-content">
                    <Box
                      component="img"
                      className="uploadedImg"
                      alt="MM Icon"
                      src={formik.values.transportUrl}
                      height={300}
                      width="auto"
                    />
                    <Box className="cancel-button">
                      <CancelOutlinedIcon
                        sx={{ color: 'black' }}
                        onClick={() => handleRemove('transportUrl')}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              {formik.touched.transportUrl && formik.errors.transportUrl && (
                <FormHelperText sx={{ color: 'red' }}>{formik.errors.transportUrl}</FormHelperText>
              )}
            </FormControl>
            <FormControl className='col-3 my-3 mt-4'>
              <Typography className='' variant='subtitle2'>Aldi Icon</Typography>
              <Box
                className="mt-2 d-flex align-items-center justify-content-center"
                height={300}
                width={{ xs: '100%', md: '300px !important' }}
                border="1px dashed #00000033"
                borderRadius={5}
              >
                {formik.values.aldiUrl.length === 0 ? (
                  <Box className="image-container" position="relative" width="fit-content">
                    <label
                      htmlFor="file-upload"
                      className="form-caption"
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(event) => handleFileChange(event, 'aldiUrl')}
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box
                          component="img"
                          height={36}
                          width={36}
                          src={upload}
                          alt="Upload"
                        />
                        <Typography className="form-caption">Upload Here</Typography>
                      </Box>
                    </label>
                  </Box>
                ) : (
                  <Box className="image-container" position="relative" width="fit-content">
                    <Box
                      component="img"
                      className="uploadedImg"
                      alt="MM Icon"
                      src={formik.values.aldiUrl}
                      height={300}
                      width="auto"
                    />
                    <Box className="cancel-button">
                      <CancelOutlinedIcon
                        sx={{ color: 'black' }}
                        onClick={() => handleRemove('aldiUrl')}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
              {formik.touched.aldiUrl && formik.errors.aldiUrl && (
                <FormHelperText sx={{ color: 'red' }}>{formik.errors.aldiUrl}</FormHelperText>
              )}
            </FormControl>
          </Box>

        </Box>

      </form>
    </Box>
  )
}

export default AddorUpdateCategory
